import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";

import { Task } from "@/core/types";

import { useStripRoutesMutation } from "../../hooks/routes";
import { useModal } from "./useModal";

export default function ConfirmStripRoute({
  task,
  onComplete,
}: {
  task: Task;
  onComplete?: () => void;
}) {
  const { close } = useModal();
  const mutation = useStripRoutesMutation();

  const onConfirm = async () => {
    if (!task.route) {
      return;
    }
    await mutation.mutateAsync({
      routeUuids: [task.route.uuid],
      endTime: "NOW",
    });
    onComplete?.();
    close();
  };

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          This will strip the route from the gym and move it to the Archive. A completed stripping
          task will be added to the schedule.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={onConfirm}
          loading={mutation.isPending}
          loadingPosition="start"
          sx={{ flex: 1 }}
        >
          Strip Route
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
